exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".print-student-log{cursor:pointer;padding-top:0;border-bottom:none}.print-student-log h1{margin:0;font-size:24px}.print-student-log h2{font-size:20px;margin:4px;padding-top:12px}.print-student-log h3{padding-top:30px;margin:4px}.print-student-log h4{font-size:16px;margin:4px}.print-student-log p{margin:4px;margin-left:16px;padding-bottom:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/containers/print-student-log/style.scss
// module id = 278
// module chunks = 0